import React from "react";
import styled from "@emotion/styled";
import Button from "@components/Button";
import { useTranslations } from "next-intl";

function RemaxFranchise() {
  const jumpToFranchise = (event: any) => {
    const anchor = (event.target?.ownerDocument || document).querySelector(
      "#franchise-content"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const translation = useTranslations("franchise");
  const translationRemaxFranchise = useTranslations("franchise.remaxFranchise");

  const [franchise, franchiseTwo] = translation("title").split(" ");

  return (
    <Wrapper>
      <BackgroundImage />
      <CoverDetails>
        <CoverContainer className="container">
          <CoverContent>
            <h1>
              <span>{franchise}</span> {franchiseTwo}
            </h1>
            <p>{translationRemaxFranchise("description")}</p>
            <p>{translationRemaxFranchise("info")}</p>

            <CoverButton onClick={jumpToFranchise} component="a">
              {translationRemaxFranchise("getFranchise").toUpperCase()}
            </CoverButton>
          </CoverContent>
        </CoverContainer>
      </CoverDetails>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  position: relative;
  margin-bottom: -200px;

  @media screen and (max-width: 991px) {
    margin-bottom: 0;
  }
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 130dvh;
  background-position: center right;
  transform: scaleX(-1);
  margin-top: 70px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("/images/v2/pic/image-03.webp");

  @media screen and (max-width: 991px) {
    height: 60vw;
  }
`;

const CoverDetails = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;

  @media screen and (max-width: 991px) {
    position: static;
    height: auto;
    background-color: var(--color-brand-blue-main);
  }
`;

const CoverContainer = styled.div`
  height: 100%;
  position: relative;

  @media screen and (max-width: 1300px) {
    position: static;
  }
`;

const CoverContent = styled.div`
  position: absolute;
  right: 0;
  top: 190px;
  width: 563px;
  padding: 40px 57px 100px;
  background-color: var(--color-brand-blue-main);
  border-radius: 15px;

  & > h1 {
    font-size: 1.938rem;
    font-weight: 700;
    color: var(--color-text-white);
    margin-bottom: 33px;

    & > span {
      // text-transform: lowercase;
    }
  }

  & > p {
    color: var(--color-text-white);
    font-size: 15.6px;
    font-weight: 400;
    margin-bottom: 20px;
    line-height: 18px;
  }

  @media screen and (max-width: 991px) {
    text-align: center;
  }

  @media screen and (max-width: 1300px) {
    right: 20px;
  }

  @media screen and (max-width: 991px) {
    position: static;
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const CoverButton = styled(Button)`
  position: absolute;
  bottom: -20px;
  margin: 0 auto;
  max-width: 265px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 100%;
  border-radius: 15px !important;
  font-size: 15px;
`;

export default RemaxFranchise;
